import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import TradeZakatTable from "./TradeZakatTable";
import { SERVER_URL } from "./ConstantsIslamicCalculator";
import { Trade_Zakat_EndPoint } from "./ConstantsIslamicCalculator";
import SharedHelmet from "../Helmet";
const TITLE = "Calculatrice Zakat sur le commerce - Calculez votre zakat commerciale avec précision";
const DESCRIPTION =
  "Calculatrice Zakat sur le commerce - Calculez votre zakat commerciale avec précision pour effectuer vos calculs islamiques de facon claire et rapide. Outil pratique pour verifier vos donnees et obtenir un resultat fiable en ligne.";
const KEYWORDS =
  "zakat sur le commerce votre zakat commerciale avec précision, calculatrice zakat sur le commerce votre zakat commerciale avec précision, calcul en ligne, zakat, heritage, calcul islamique, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/trade-zakat/";
const apiEndpoint = `${SERVER_URL}/${Trade_Zakat_EndPoint}`;
function TradeZakatCalculator() {
  const [cash, setCash] = useState(0);
  const [yearType, setYearType] = useState("");
  const [gramPriceGold, setGramPriceGold] = useState(0);
  const [gramPriceSilver, setGramPriceSilver] = useState(0);
  const [debtsReceivable, setDebtsReceivable] = useState(0);
  const [debtsPayable, setDebtsPayable] = useState(0);
  const [merchandise, setMerchandise] = useState(0);
  const [result, setRestul] = useState(null);
  const [error, setError] = useState(null);
  const [statusCode, setStatusCode] = useState(null);
  const [classification, setClassification] = useState(null);
  const [thresholdType, setThresholdType] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const handleThresholdTypeChange = (event) => {
    const newThresholdType = event.target.value;
    setThresholdType(newThresholdType);
    if (newThresholdType === "gold") {
      setGramPriceSilver(0);
    } else if (newThresholdType === "silver") {
      setGramPriceGold(0);
    }
  };
  const handleYearTypeChange = (event) => {
    setYearType(event.target.value);
  };
  const handleCashChange = (event) => {
    setCash(event.target.value);
  };
  const handleDebtsReceivableChange = (event) => {
    setDebtsReceivable(event.target.value);
  };
  const handleMerchandiseChange = (event) => {
    setMerchandise(event.target.value);
  };
  const handleDebtsPayableChange = (event) => {
    setDebtsPayable(event.target.value);
  };
  const handleGramPriceGoldChange = (event) => {
    setGramPriceGold(event.target.value);
  };
  const handleGramPriceSilverChange = (event) => {
    setGramPriceSilver(event.target.value);
  };
  const calculateTradeZakat = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(apiEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          merchandise,
          cash,
          debtsReceivable,
          debtsPayable,
          yearType,
          gramPriceGold,
          gramPriceSilver,
        }),
      });
      const data = await response.json();
      setStatusCode(response.status);
      if (response.ok) {
        setRestul(data.result);
        setError(null);
        setClassification(data.result.classification);
      } else {
        setRestul(null);
        setError(data.error);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>Calculez la zakat sur le commerce</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                La calculatrice zakat commerce est un outil conçu pour faciliter le calcul du montant de la zakat due sur le commerce selon les principes religieux. L'outil vise à fournir une solution rapide et précise pour les individus et les commerçants qui souhaitent déterminer le montant de la zakat selon les normes religieuses approuvées.
                <br />
                <hr />
              </div>
              <br />
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-5 calculatorStyle">
                <div className='p-3 mb-2 bg-success text-white'>
                  Zakat sur le commerce
                </div>
                <hr />
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor='yearType' >Type d'année</label>
                  </b>
                  <div className="form-check form-check-inline">
                    <input
                      type="radio"
                      name="yearType"
                      value="gregorian"
                      id="gregorian"
                      checked={yearType === "gregorian"}
                      onChange={handleYearTypeChange}
                      className="form-check-input"
                    />
                    <label className="form-check-label" htmlFor="gregorian">
                      Grégorienne
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      type="radio"
                      name="yearType"
                      id="hijri"
                      value="hijri"
                      checked={yearType === "hijri"}
                      onChange={handleYearTypeChange}
                      className="form-check-input"
                    />
                    <label className="form-check-label" htmlFor="hijri">
                      Hijri
                    </label>
                  </div>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor='merchandiseNumber' className="form-label ms-2">Marchandises commerciales </label>
                  </b>
                  <input
                    type="number"
                    id="merchandiseNumber"
                    value={merchandise}
                    onChange={handleMerchandiseChange}
                    className="form-control ml-2"
                    style={{ width: '90%' }}
                  />
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor='cashNumber' className="form-label ms-2">Montant total (Espèces)</label>
                  </b>
                  <input
                    type="number"
                    id="cashNumber"
                    value={cash}
                    onChange={handleCashChange}
                    className="form-control ml-2"
                    style={{ width: '90%' }}
                  />
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor='debtsReceivableNumber' className="form-label ms-2">Créances recouvrable</label>
                  </b>
                  <input
                    type="number"
                    id="debtsReceivableNumber"
                    value={debtsReceivable}
                    onChange={handleDebtsReceivableChange}
                    className="form-control ml-2"
                    style={{ width: '90%' }}
                  />
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor='debtsPayableNumber' className="form-label ms-2">Dettes du commerçant</label>
                  </b>
                  <input
                    type="number"
                    id="debtsPayableNumber"
                    value={debtsPayable}
                    onChange={handleDebtsPayableChange}
                    className="form-control ml-2"
                    style={{ width: '90%' }}
                  />
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor='thresholdType' >Type de seuil</label>
                  </b>
                  <div className="form-check form-check-inline">
                    <input
                      type="radio"
                      name="thresholdType"
                      value="gold"
                      id="gold"
                      checked={thresholdType === "gold"}
                      onChange={handleThresholdTypeChange}
                      className="form-check-input"
                    />
                    <label className="form-check-label" htmlFor="gold">
                      Or
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      type="radio"
                      name="thresholdType"
                      value="silver"
                      id="silver"
                      checked={thresholdType === "silver"}
                      onChange={handleThresholdTypeChange}
                      className="form-check-input"
                    />
                    <label className="form-check-label" htmlFor="silver">
                      Argent
                    </label>
                  </div>
                </div>
                <br />
                {thresholdType === "gold" && (
                  <div className="form-group d-flex align-items-center">
                    {gramPriceSilver == 0}
                    <b>
                      <label htmlFor='gramPriceGoldNumber' className="form-label ms-2">Prix du gramme d'or (24 carats)</label>
                    </b>
                    <input
                      type="number"
                      id="gramPriceGoldNumber"
                      value={gramPriceGold}
                      onChange={handleGramPriceGoldChange}
                      className="form-control ml-2"
                      style={{ width: '90%' }}
                    />
                  </div>
                )}
                {thresholdType === "silver" && (
                  <div className="form-group d-flex align-items-center">
                    {gramPriceGold == 0}
                    <b>
                      <label htmlFor='gramPriceSilverNumber' className="form-label ms-2">Prix du gramme d'argent (99.9 carats)</label>
                    </b>
                    <input
                      type="number"
                      id="gramPriceSilverNumber"
                      value={gramPriceSilver}
                      onChange={handleGramPriceSilverChange}
                      className="form-control ml-2"
                      style={{ width: '150px' }}
                    />
                  </div>
                )}
                <br/>
                <hr />
                <button
                  className="btn btn-success"
                  style={{ fontSize: "20px" }}
                  onClick={calculateTradeZakat}
                       >
                    Calculer
                </button>
              </div>
              <div className="col-12 col-md-7">
                <br />
                {statusCode === 400 && (
                  <div className="alert alert-warning">
                    <b>
                      <u> Erreur :</u>
                    </b>{" "}
                    Veuillez remplir tous les champs correctement.{" "}
                  </div>
                )}
                {result && (
                  <div>
                    <h4>
                      <div className="p-3 mb-2 bg-success text-white">
                        Résultats:{" "}
                      </div>
                    </h4>
                    <hr />
                    <TradeZakatTable result={result}></TradeZakatTable>
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                Description de la calculatrice Zakat sur le commerce
              </div>
              <div className="info-section-body">
                <u>
                  <b> Calculatrice Zakat sur le commerce </b>{" "}
                </u>{" "}
                <br/>
                La calculatrice zakat commerce calcule la zakat sur le commerce en tenant compte de plusieurs facteurs, notamment:
                <ul>
                  <li>La valeur de la marchandise commerciale</li>
                  <li>Le montant total en espèces</li>
                  <li>Les créances recouvrables</li>
                  <li>Les dettes du commerçant</li>
                  <li>Le type d'année civile (hijri ou grégorienne)</li>
                  <li>Les prix du gramme d'or ou d'argent (selon le type de seuil)</li>
                </ul>
                La calculatrice combine tous ces éléments pour déterminer le montant exact de la zakat due selon les normes religieuses islamiques. Le montant final est présenté dans un rapport clair incluant l'obligation de la zakat, le montant total, le seuil appliqué et la zakat due.
                <br/>
                <hr />
                <b>Dernière révision : </b>
                28/02/2026
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default TradeZakatCalculator;
